<template>
  <router-view></router-view>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import Swal from "sweetalert2";
import router from "./router";
import { clearClientSession } from "@/helpers/sessionHelper";

export default {
  name: "App",
  components: {},
  setup() {
    let idleTimer = null;
    const idleTime = 90 * 60 * 1000; // 90 minutes (1.5 hours)

    const resetTimer = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(logout, idleTime);
    };

    const logout = () => {
      const currentPath = (window.location.pathname || "").toLowerCase();
      const isLoginOrLogoutPage =
        currentPath.includes("/login") ||
        currentPath.includes("/logout");

      // Jangan tampilkan jika sudah di halaman login/logout atau belum pernah login
      if (isLoginOrLogoutPage || !localStorage.getItem("session")) {
        return;
      }

      Swal.fire({
        icon: 'warning',
        title: 'Sesi Anda telah berakhir',
        text: 'Karena tidak ada aktivitas, sesi Anda telah berakhir.',
        confirmButtonText: 'OK',
      }).then(() => {
        clearClientSession();
        if (!window.location.pathname.toLowerCase().includes("/login")) {
          router.push('/login').catch(() => {});
        }
      });
    };

    onMounted(() => {
      window.addEventListener('mousemove', resetTimer);
      window.addEventListener('keypress', resetTimer);
      resetTimer(); // Initial timer setup
    });

    onUnmounted(() => {
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keypress', resetTimer);
      clearTimeout(idleTimer);
    });

    return {};
  },
};
</script>

<style>
.container-image-soal {
  position: relative;
  width: 100%;
}

.container-image {
  position: relative;
  width: 100px;
}

.image {
  opacity: 1;
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  margin: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.image-soal {
  opacity: 1;
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  margin: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  cursor: pointer;
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  text-align: center;
}

.container-image-soal:hover .middle {
  opacity: 1;
}

.container-image:hover .middle {
  opacity: 1;
}
</style>
